var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-modal', {
    attrs: {
      "delay": 100,
      "classes": ['generic-modals', 'v--modal', 'feature-tab-modal'],
      "name": "featureTabModal",
      "width": "70%",
      "height": "auto",
      "pivotY": 0.3
    },
    on: {
      "before-open": _vm.beforeOpen,
      "closed": _vm.closeModal
    }
  }, [_c('section', {
    staticClass: "feature-tab-modal__wrapper"
  }, [_c('div', {
    staticClass: "feature-tab-modal__inner"
  }, [_c('h2', {
    staticClass: "feature-tab-modal__title feature-title"
  }, [_vm._v("\n        " + _vm._s(_vm.featureTab.title) + "\n      ")]), _c('div', {
    staticClass: "feature-tab-modal__body"
  }, [_vm.featureTab.imageUrl ? _c('img', {
    staticClass: "feature-tab-modal__img",
    attrs: {
      "src": "".concat(_vm.imgSrcUrl),
      "alt": _vm.featureTab.title
    }
  }) : _vm._e(), _c('p', {
    staticClass: "feature-tab-modal__description"
  }, [_vm._v(_vm._s(_vm.featureTab.description))])])]), _c('div', {
    attrs: {
      "slot": "top-right"
    },
    slot: "top-right"
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }